import { useCallback } from "react";
import useCurrentUserManager from "@/hooks/use-current-user-manager";
import usePersistedBoundStore from "@/store/persisted-bound-store";
import type { RealmSliceState } from "@/store/realm-slice";
import { isAuthenticated } from "@/utils/auth";

export default function useChangeRealm() {
  const currentUserManager = useCurrentUserManager();
  const setRealm = usePersistedBoundStore.use.setRealm();

  const changeRealm = useCallback(
    async (nextRealm: RealmSliceState["realm"]) => {
      if (!currentUserManager) {
        throw new Error("CurrentUserManager is not available");
      }

      try {
        if (await isAuthenticated(currentUserManager)) {
          await currentUserManager.signoutRedirect();
        }
      } catch (error) {
        throw new Error(
          "Unimplemented feature: redirect to some kind of error page on failed signoutRedirect" +
            error
        );
      }
      setRealm(nextRealm);
    },
    [currentUserManager, setRealm]
  );

  return changeRealm;
}
